import React from 'react'

const ListHeader = ({ children }) => (
  <div className='lbv2__list-header'>
    <h2>{children}</h2>
  </div>
)

export default ListHeader;